module.exports = __webpack_public_path__ + "img/lasource-17.cebdec9c.jpg";